export const refreshJwtToken = async () => {
  if (!window.apgigya.jwtIsExpired()) return

  // if the JWT has expired, call the JWT endpoint
  // https://developers.gigya.com/display/GD/accounts.getJWT+JS
  await new Promise((resolve) => {
    window.apgigya.getSecurityToken({ callback: resolve })
  })
}
